import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { VideoPosterPipe } from './video-poster.pipe';
import { VideoPipe } from './video.pipe';

@NgModule({
  imports: [CommonModule, VideoPipe, VideoPosterPipe],
  exports: [VideoPipe, VideoPosterPipe],
})
export class VideoPipeModule {}
